var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"video-embed",class:[
    {
      'p-absolute': !_vm.relative,
      'p-relative': _vm.relative
    },
    'video-embed w-100 h-100 d-flex align-items-center justify-content-center'
  ]},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.isPlaying)?_c('div',{staticClass:"video-embed__thumbnail p-overlay z-3",style:({
        backgroundImage: ("url(" + _vm.thumbnailUrl + ")"),
        opacity: _vm.thumbnailOpacity
      })}):_vm._e()]),_c('transition',{attrs:{"name":"fade"}},[(
        _vm.isBuilderContext() ||
          !this.isInitialized ||
          ((this.isYoutube || this.isMux) && this.autoplay && !this.isPlaying)
      )?_c('div',{staticClass:"p-overlay video-embed__controls-overlay z-3",on:{"click":_vm.toggle}},[_c('play-button',{staticClass:"video-embed__play",attrs:{"is-loading":_vm.isLoading,"data-cy":"play","plyr":"play"}})],1):_vm._e()]),_c('div',{class:[
      {
        '--playing': _vm.isPlaying,
        '--loading': _vm.isLoading,
        '--muted': _vm.isMuted,
        '--has-interacted': _vm.hasUserInteracted,
        '--vimeo': _vm.isVimeo,
        '--youtube': _vm.isYoutube,
        '--mux': _vm.isMux
      },
      'video-embed__video w-100 h-100'
    ],attrs:{"data-cy":"video-embed"},on:{"click":_vm.preventNavigation}},[(_vm.isFacebook)?[_c('div',{staticClass:"facebook-video fb-video",attrs:{"data-role":"facebook-video","data-href":_vm.video.link,"data-width":"auto","data-allowfullscreen":"false","data-autoplay":"true","data-controls":"false"}})]:(_vm.isMux)?[(!_vm.isBuilderContext())?_c('video',{attrs:{"controls":"","crossorigin":"","playsinline":"","id":_vm.playerId}}):_vm._e()]:(_vm.isMounted)?_c('div',{staticClass:"plyr__video-embed",attrs:{"id":_vm.playerId}},[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.embedLink,"allowfullscreen":"","allowtransparency":"","allow":"autoplay; fullscreen;"}})]):_vm._e(),(!_vm.hideControls && _vm.isPlaying && _vm.isMuted)?_c('div',{staticClass:"video-embed__tooltip --muted",on:{"click":_vm.unmute}},[_vm._v(" Tap to unmute ")]):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }